import style from "./index.module.css";
import { UseFormRegister } from "react-hook-form";
import VehicleTypesControllers from "../../components/General/VehiclesControllers";
import { useHistory } from "react-router-dom";
import { ComponentProps, useEffect, useRef, useState } from "react";
import LoadingSkeleton from "../../components/UI/LoadingSkeleton";
import vehicleTypeCategoriesStyle from "./vehicle-type-categories.module.css";
import { useTranslation } from "../../hooks/useTranslation";
import { VehicleNames, VehicleTypesT } from "../../utils/GeneralTypes";
import { useTypedSelector } from "../../store/store";
import {
  selectTypeCategories,
  selectTypeCategoriesError,
  selectTypeCategoriesLoading,
} from "../../store/vehicleTypeCategoriesSlice";

export function VehicleCategoriesStep({
  vehicleName,
  error,
  register,
  isEditing,
  vehicleType: choosedVehicle,
  setValue,
  nextPageHandler,
}: {
  register: UseFormRegister<any>;
  vehicleName: VehicleNames;
  error?: string;
  isEditing: boolean;
  vehicleType: VehicleTypesT;
  setValue: CallableFunction;
  nextPageHandler: () => void;
}) {
  const { locale } = useTranslation();
  const history = useHistory();
  const { onChange, ...categoryInputRegisterInfo } = register("category_0", {
    required: {
      value: true,
      message: locale("required_field"),
    },
    validate: (val) => {
      return (val !== undefined && val !== "no_option") || locale("required_field");
    },
  });

  return (
    <>
      {!isEditing && (
        <div className={style.page_section}>
          <h4 className={style.page_section__title}>{locale("vehicle_type")}</h4>
          <VehicleTypesControllers
            active={choosedVehicle}
            baseLink=""
            isBtn={true}
            onClickHandler={(vehicleType: VehicleTypesT) =>
              history.push({
                pathname: `/sell-vehicle/${vehicleType}`,
              })
            }
          />
        </div>
      )}
      <div className={style.page_section}>
        <VehicleTypeCategories
          vehicleModule={vehicleName}
          onSelectionChange={(category0Id) => {
            setValue("category_0", category0Id.toString());
          }}
          inputProps={{
            ...categoryInputRegisterInfo,
            onClick: (e) => {
              onChange(e);
              nextPageHandler();
            },
          }}
        />
        {error && (
          <span className={style.input_note} style={{ color: "#dc0000" }}>
            {error}
          </span>
        )}
      </div>
    </>
  );
}

function ItemContent({ category }: { category: Category }) {
  return (
    <>
      <img src={category.icon} alt="" />
      <div className={vehicleTypeCategoriesStyle.single_cat__child_title}>
        <p>{category.name}</p>
      </div>
    </>
  );
}

const VehicleTypeCategories = ({ vehicleModule, inputProps, onSelectionChange }: ComponentPropsType) => {
  const { locale } = useTranslation();
  const categories = useTypedSelector((state) => selectTypeCategories(state, vehicleModule.single));
  const isLoading = useTypedSelector((state) => selectTypeCategoriesLoading(state, vehicleModule.single));
  const error = useTypedSelector((state) => selectTypeCategoriesError(state, vehicleModule.single));

  if (error) return <div>Error: {error}</div>;
  if (!categories) return null;

  return (
    <div
      className={`${vehicleTypeCategoriesStyle.all_cats} row`}
      style={{
        width: "100%",
      }}
    >
      {isLoading ? (
        <>
          <div className="col-sm-6">
            <LoadingSkeleton count={3} height="15px" />
          </div>
          <div className="col-sm-6">
            <LoadingSkeleton count={3} height="15px" />
          </div>
        </>
      ) : (
        <>
          <h4 className={vehicleTypeCategoriesStyle.page_section__title}>{locale("chooseVehicleCategory")}</h4>
          <div
            style={{
              width: "100%",
            }}
          >
            <div
              className={"d-flex flex-column"}
              style={{
                width: "100%",
                // gap: "1em",
              }}
            >
              <div className={`${vehicleTypeCategoriesStyle.single_cat__children} row`}>
                {categories.map((category, index) => {
                  return (
                    <div key={index} className="col-6 col-sm-3 col-lg-2">
                      <div className={vehicleTypeCategoriesStyle.radio_wrapper}>
                        <input
                          {...inputProps}
                          type="radio"
                          id={category.id.toString()}
                          value={category.id}
                          className="d-none category-radio"
                          onChange={(e) => {
                            if (onSelectionChange) onSelectionChange(category.id);
                            if (inputProps.onChange) {
                              inputProps.onChange(e);
                            }
                          }}
                        />
                        <label
                          htmlFor={category.id.toString()}
                          className={`${vehicleTypeCategoriesStyle.single_cat__child} category-label`}
                          style={{
                            cursor: "pointer",
                          }}
                        >
                          <ItemContent category={category} />
                        </label>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

type Category = {
  id: number;
  name: string;
  icon: string;
};

type ComponentPropsType = {
  vehicleModule: VehicleNames;
  onSelectionChange?: (category0Id: number) => void;
  inputProps: ComponentProps<"input">;
};
